var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { keyframes } from "styled-components";
import tinycolor from "tinycolor2";
var disappearAnimation = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0% {opacity: 1; }\n  100% { opacity: 0; }\n"], ["\n  0% {opacity: 1; }\n  100% { opacity: 0; }\n"])));
export var FormAlert = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: block;\n  width: 100%;\n  margin: 10px 0;\n  opacity: 1;\n  padding: 10px 18px 8px 18px;\n  font-size: 1.4rem;\n  font-weight: 400;\n  letter-spacing: 0.2px;\n  line-height: 1.2em;\n  border: 1px solid transparent;\n  border-radius: ", ";\n  transition: opacity ", " ease;\n  &.alert-success {\n    background-color: ", ";\n    color: ", ";\n    a {\n      color: ", ";\n    }\n    &:hover {\n      border-color: ", ";\n    }\n  }\n  &.alert-error {\n    background-color: ", ";\n    color: ", ";\n    a {\n      color: ", ";\n    }\n    &:hover {\n      border-color: ", ";\n    }\n  }\n  &.type-warning {\n    background-color: ", ";\n    color: ", ";\n    a {\n      color: ", ";\n    }\n    &:hover {\n      border-color: ", ";\n    }\n  }\n  &.isHidden {\n    animation: ", ";\n    animation-duration: ", ";\n    animation-iteration-count: 1;\n    animation-fill-mode: forwards;\n  }\n"], ["\n  display: block;\n  width: 100%;\n  margin: 10px 0;\n  opacity: 1;\n  padding: 10px 18px 8px 18px;\n  font-size: 1.4rem;\n  font-weight: 400;\n  letter-spacing: 0.2px;\n  line-height: 1.2em;\n  border: 1px solid transparent;\n  border-radius: ", ";\n  transition: opacity ", " ease;\n  &.alert-success {\n    background-color: ", ";\n    color: ", ";\n    a {\n      color: ",
    ";\n    }\n    &:hover {\n      border-color: ",
    ";\n    }\n  }\n  &.alert-error {\n    background-color: ", ";\n    color: ", ";\n    a {\n      color: ",
    ";\n    }\n    &:hover {\n      border-color: ",
    ";\n    }\n  }\n  &.type-warning {\n    background-color: ", ";\n    color: ", ";\n    a {\n      color: ",
    ";\n    }\n    &:hover {\n      border-color: ",
    ";\n    }\n  }\n  &.isHidden {\n    animation: ", ";\n    animation-duration: ", ";\n    animation-iteration-count: 1;\n    animation-fill-mode: forwards;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.borders.radius;
}, function (_a) {
    var theme = _a.theme;
    return theme.transitions.normal;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.alerts.success.bg;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.alerts.success.color;
}, function (_a) {
    var theme = _a.theme;
    return tinycolor(theme.gwThemed.alerts.success.bg).darken(60).toString();
}, function (_a) {
    var theme = _a.theme;
    return tinycolor(theme.gwThemed.alerts.success.bg).darken(25).toString();
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.alerts.error.bg;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.alerts.error.color;
}, function (_a) {
    var theme = _a.theme;
    return tinycolor(theme.gwThemed.alerts.error.bg).darken(45).toString();
}, function (_a) {
    var theme = _a.theme;
    return tinycolor(theme.gwThemed.alerts.error.bg).darken(25).toString();
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.alerts.warning.bg;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.alerts.warning.color;
}, function (_a) {
    var theme = _a.theme;
    return tinycolor(theme.gwThemed.alerts.warning.bg).darken(55).toString();
}, function (_a) {
    var theme = _a.theme;
    return tinycolor(theme.gwThemed.alerts.warning.bg).darken(15).toString();
}, disappearAnimation, function (_a) {
    var theme = _a.theme;
    return theme.transitions.normal;
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=FormAlert.js.map